export class MobileBackButton extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.render();
		this.remove();
	}
	render() {
		this.insertAdjacentHTML("afterend", `
			<span>
				<button class="btn-a w-full text-left" data-back-btn="true">
					<i class="inline-block fa-light fa-chevron-left"></i>
					Back
				</button>
			</span>
		`);
	}
}

export default MobileBackButton;